export const MAX_MENU_HEIGHT = '450px';
export const MIN_MENU_WIDTH = '250px';

export default { MAX_MENU_HEIGHT, MIN_MENU_WIDTH };
